import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import interior1 from '../images/interior-seagull-1.jpg';
import interior2 from '../images/interior-seagull-2.jpg';
import interior3 from '../images/interior-seagull-3.jpg';
import interior4 from '../images/interior-seagull-4.jpg';
import interior5 from '../images/interior-seagull-5.jpg';
import interior6 from '../images/interior-seagull-6.jpg';
import interior7 from '../images/interior-seagull-7.jpg';
import interior8 from '../images/interior-seagull-8.jpg';

function InteriorSeagull() {
  const interiors = [
    {
      image: interior1,
      title: '🎛️ Layar Sentuh Utama & Dashboard Futuristik',
      desc: 'Layar sentuh besar beresolusi tinggi menjadi pusat kendali digital BYD Atto1. Semua fitur mulai dari musik, navigasi, hingga kontrol AC bisa diakses dari layar ini. Desainnya yang minimalis namun modern memberikan kesan mewah tanpa harus mahal. Cocok banget buat Gen Z dan milenial yang ingin smart car dengan interface interaktif dan intuitif.',
    },
    {
      image: interior2,
      title: '📱 Wireless Charging: Ngecas HP Jadi Makin Mudah',
      desc: 'Fitur wireless charging pad di BYD Atto1 bikin pengalaman berkendara lebih praktis. Cukup letakkan smartphone kamu di konsol tengah, dan proses charging langsung dimulai tanpa kabel. Cocok buat kamu yang aktif dan selalu on-the-go.',
    },
    {
      image: interior3,
      title: '🔘 Tombol Putar Multifungsi',
      desc: 'Desain tombol-tombol kendali seperti P-R-N-D, mode berkendara, AC, dan lampu hazard dibuat dalam bentuk silinder putar yang keren dan ergonomis. Nggak hanya unik, tapi juga fungsional dan memberi pengalaman berkendara yang futuristik.',
    },
    {
      image: interior4,
      title: '🪑 Jok Depan dengan Kombinasi Hitam & Pink',
      desc: 'Desain jok depan BYD Atto1 menggunakan material kulit sintetis dengan perpaduan warna hitam dan pink yang elegan. Bentuknya mendukung postur tubuh, nyaman untuk perjalanan jauh maupun harian. Jahitan dan finishing-nya juga rapi banget.',
    },
    {
      image: interior5,
      title: '🛋️ Jok Belakang Lapang & Stylish',
      desc: 'Ruang kabin belakang didesain nyaman untuk tiga penumpang. Kombinasi warna dan ergonomi tetap dijaga untuk memberikan kenyamanan dan estetika tinggi. BYD Atto1 membuktikan bahwa mobil mungil tetap bisa terasa lega di dalam.',
    },
    {
      image: interior6,
      title: '💺 Pengaturan Jok Elektrik',
      desc: 'Fitur pengaturan kursi elektrik di kursi pengemudi menambah kenyamanan dan fleksibilitas dalam berkendara. Nggak perlu manual tarik-tarikan tuas—cukup tekan tombol dan atur posisi sesuai selera.',
    },
    {
      image: interior7,
      title: '🧳 Bagasi Fleksibel & Bisa Diperluas',
      desc: 'BYD Atto1 punya kapasitas bagasi yang impresif untuk ukuran city car. Saat bangku belakang dilipat rata, kamu bisa bawa barang lebih banyak—dari koper, sepeda lipat, hingga perlengkapan camping ringan.',
    },
    {
      image: interior8,
      title: '🖥️ Tampilan Interior Minimalis Modern',
      desc: 'Secara keseluruhan, desain interior BYD Atto1 menyatu dalam estetika modern minimalis. Garis-garis lembut, warna pastel, dan dashboard melengkung memberikan kesan harmonis dan futuristik. Cocok banget buat anak muda yang mencari sesuatu yang beda dari mobil konvensional.',
    },
  ];

  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <Helmet>
        <title>
          Interior BYD Atto1 2025 - Desain Modern, Fitur Canggih & Kenyamanan
          Maksimal
        </title>
        <meta
          name='description'
          content='Jelajahi interior BYD Atto1 2025 secara mendalam. Temukan fitur-fitur unggulan seperti layar sentuh digital, wireless charging, dan jok kulit kombinasi pink-hitam yang modern.'
        />
        <meta
          name='keywords'
          content='Interior BYD Atto1, fitur byd Atto1 2025, dashboard BYD Atto1, BYD BSD Serpong'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/interior-byd-atto1'
        />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        Interior BYD Atto1 2025: Smart, Stylish, dan Siap Bersaing
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        BYD Atto1 hadir sebagai mobil listrik mungil yang memadukan desain
        modern dengan fitur-fitur canggih di dalam kabin. Meskipun ukurannya
        compact, namun interiornya dirancang dengan sangat apik, memberikan
        kesan lega, fungsional, dan futuristik. Di artikel ini, kita akan bedah
        semua detail interiornya yang bisa bikin kamu bilang “kok bisa semewah
        ini dengan harga segitu?” 😍
      </Typography>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        {interiors.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                sx={{ width: '100%', maxHeight: 500, objectFit: 'cover' }}
              />
              <Box sx={{ padding: 3 }}>
                <Typography variant='h5' fontWeight='bold' gutterBottom>
                  {item.title}
                </Typography>
                <Typography
                  variant='body1'
                  sx={{ fontSize: '1.05rem', lineHeight: 1.8 }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🧠 FAQ: Pertanyaan Umum Seputar Interior BYD Atto1
        </Typography>
        <Typography variant='h6' fontWeight='bold' mt={3}>
          ❓ Apakah interior BYD Atto1 terasa sempit?
        </Typography>
        <Typography paragraph>
          Justru sebaliknya! Walaupun eksteriornya compact, desain interior BYD
          Atto1 dirancang untuk memberi kesan lapang dengan layout ergonomis
          dan fitur-fitur ringkas namun fungsional.
        </Typography>

        <Typography variant='h6' fontWeight='bold' mt={3}>
          ❓ Apakah jok kulit asli?
        </Typography>
        <Typography paragraph>
          Material yang digunakan adalah kulit sintetis berkualitas tinggi yang
          mudah dibersihkan dan tetap nyaman untuk penggunaan jangka panjang.
        </Typography>

        <Typography variant='h6' fontWeight='bold' mt={3}>
          ❓ Bisa muat banyak barang?
        </Typography>
        <Typography paragraph>
          Yes! Bagasi bisa diperluas dengan melipat kursi belakang. Cocok buat
          kamu yang suka road trip atau bawa perlengkapan belanja mingguan.
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🗣️ Komentar Pelanggan Fiktif (untuk SEO & Realisme)
        </Typography>
        <Typography variant='body1' paragraph>
          <strong>Rina (27, Jakarta):</strong> “Interior Atto1 bikin aku jatuh
          cinta sejak duduk pertama! Warna pink-nya lembut, joknya nyaman
          banget. Rasanya kayak naik mobil mewah tapi ramah kantong.”
        </Typography>
        <Typography variant='body1' paragraph>
          <strong>Kevin (34, Bandung):</strong> “Biasanya mobil kecil tuh sempit
          dan fiturnya seadanya, tapi Atto1 beda. Layar besar, tombol muter
          unik, dan ada wireless charging pula. Gokil sih.”
        </Typography>
        <Typography variant='body1' paragraph>
          <strong>Ayumi (22, Bali):</strong> “Aku beli yang warna pink dan
          setiap kali masuk mobil, rasanya kayak masuk ke dunia Barbie versi
          futuristik. Interiornya cocok banget buat Gen Z!”
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          📣 Review Realistis ala Influencer Otomotif
        </Typography>
        <Typography variant='body1' paragraph>
          “Kalau ngomongin mobil listrik entry-level, BYD Atto1 bisa dibilang
          juaranya. Interiornya itu loh—nggak cuma sekadar manis dilihat, tapi
          juga canggih. Layar sentuh besar, kontrol AC digital, hingga tombol
          putar ala pesawat luar angkasa. Apalagi joknya udah kayak sport seat
          di mobil-mobil premium. Untuk harga di bawah Rp200 juta (estimasi
          Indonesia), ini sih win banget!” — <em>@otomobil_id</em>
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Paper
          sx={{
            padding: 4,
            backgroundColor: '#e3f2fd',
            borderLeft: '6px solid #1976d2',
          }}
        >
          <Typography variant='h5' fontWeight='bold' gutterBottom>
            🎯 Ingin Lihat Langsung Interior BYD Atto1?
          </Typography>
          <Typography variant='body1' paragraph>
            Segera hubungi kami untuk jadwal test drive atau pre-order! Interior
            stylish, fitur canggih, dan kenyamanan maksimal—semuanya bisa kamu
            rasakan langsung.
          </Typography>
          <Typography variant='body2'>
            📞{' '}
            <a
              href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20melihat%20interior%20BYD%20Seagull'
              target='_blank'
              rel='noopener noreferrer'
            >
              Chat via WhatsApp
            </a>{' '}
            atau follow kami di{' '}
            <a
              href='https://instagram.com/bydbsdserpong'
              target='_blank'
              rel='noopener noreferrer'
            >
              @bydbsdserpong
            </a>
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default InteriorSeagull;
